import { render, staticRenderFns } from "./qiu.vue?vue&type=template&id=3dd3fe1c&scoped=true"
import script from "./qiu.vue?vue&type=script&lang=js"
export * from "./qiu.vue?vue&type=script&lang=js"
import style0 from "./qiu.vue?vue&type=style&index=0&id=3dd3fe1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd3fe1c",
  null
  
)

export default component.exports